import React, { useState, useEffect } from "react";
import MainLogo from "./MainLogo";
import SpriteIcons from "./SpriteIcons";
// import MenuAccordion from "./MenuAccordion";
import { Autoplay, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import CryptoIcons from "../../public/assets/crypto-icons.svg";
// import { Link, Link } from "react-router-dom";
import Link from "next/link";
import SwitchBtn from "./SwitchBtn";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
// import { GetTournaments } from "../services/tournaments";
import Image from "next/image";
// ROUTERS

const MainMenu = ({ ClassBtn = "BtnsTop" }) => {
  const { setTournamentLink, setPageLoader, user } = useContext(AppContext);
  // [DETECT SCROLLO MENU]┐
  useEffect(() => {
    const container = document.getElementById("MainMenu");
    container.addEventListener("scroll", scrollFunction);

    return () => {
      container.removeEventListener("scroll", scrollFunction);
    };
  }, []);

  function scrollFunction() {
    const container = document.getElementById("MainMenu");

    if (container.scrollTop > 50) {
      document.getElementById("BtnTgMenu").style.transform =
        "translate(-30px , -15px) scale(0.9)";
      // console.log("SCROLL DOWN");
    } else {
      document.getElementById("BtnTgMenu").style.transform =
        "translate(0px , 0px) scale(1)";
      // console.log("SCROLL TOP");
    }
  }
  // [DETECT SCROLLO MENU]┘

  const [isLMode, setIsLMode] = useState(false);
  const [menuClose, setmenuClose] = useState(true);

  const HandleBtnMMenue = (event) => {
    setIsLMode((current) => !current);
    // console.log("CLICK BTN MAIN MENU");
  };

  const HandleOpenCloseMenu = (event) => {
    setmenuClose((current) => !current);
    // console.log("TOGGLE MENU");
    document.getElementById("root").classList.toggle("MenuIsOpen");
  };

  const accordionClick = (event) => {
    // console.log("CLICK ACCORDION");
  };

  // DETECT SIZE OF DEVICE
  const [isMobile, setIsMobile] = useState(window.innerWidth < 851);
  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth < 851;
      setIsMobile(newIsMobile);

      if (newIsMobile) {
        // console.log("MOBILE");
      } else {
        // console.log("DESKTOP");
      }
    };

    window.addEventListener("resize", handleResize);

    //clear event listener
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // CSS DAM IPHONES (safari)!
  const InlineStyle = { overflowX: "hidden" };

  return (
    <>
      <div
        id="MainMenu"
        className={menuClose ? "Close" : ""}
        style={InlineStyle}
      >
        <div id="ContBtnTheme">
          <SwitchBtn />
        </div>
        <MainLogo />
        {/* BTN TOGGLE MENU */}
        <button
          className={menuClose ? "BtnToggleMenu" : "BtnToggleMenu active"}
          onClick={HandleOpenCloseMenu}
          id="BtnTgMenu"
          aria-label="TOGGLE MENU"
        >
          <svg viewBox="0 0 64 48">
            <path d="M19,15 L45,15 C70,15 58,-2 49.0177126,7 L19,37"></path>
            <path d="M19,24 L45,24 C61.2371586,24 57,49 41,33 L32,24"></path>
            <path d="M45,33 L19,33 C-8,33 6,-2 22,14 L45,37"></path>
          </svg>
        </button>
        <Link
          href="/"
          className={"BtnMainMenu P_07"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> Home
        </Link>
        {/* <Link
          // href="/games/3"
          href="/games"
          className={"BtnMainMenu P_01"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> Games
        </Link> */}
        {
          //TOURNAMENTS LINK
        }
        {/* {
            user && window.innerWidth < 500 &&
              <Link
                href='/tournaments'
                className={"BtnMainMenu P_08 AniBG_BTN"}
                // onClick={isMobile ? HandleOpenCloseMenu : null}
                onClick={!menuClose ? HandleOpenCloseMenu : null}
              >
                <SpriteIcons /> Tournaments
              </Link>
          } */}
        <Link
          href="/games"
          className={"BtnMainMenu P_05"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> Games
        </Link>
        <Link
          href="/promotions"
          className={"BtnMainMenu P_02"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> Promotions
        </Link>
        <Link
          href="/banking"
          className={"BtnMainMenu P_03"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> Banking
        </Link>
        <Link
          href="/vip-program"
          className={"BtnMainMenu P_05"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> VIP Program
        </Link>
        <Link
          href="/mybenefits"
          className={"BtnMainMenu P_06"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> My Benefits
        </Link>
        <Link
          href="/support"
          className={"BtnMainMenu P_04"}
          // onClick={isMobile ? HandleOpenCloseMenu : null}
          onClick={!menuClose ? HandleOpenCloseMenu : null}
        >
          <SpriteIcons /> Support
        </Link>
        {/* <Link href="/blog" className={"BtnMainMenu P_09"} onClick={!menuClose ? HandleOpenCloseMenu : null} ><SpriteIcons /> Blog </Link> */}
        {/* ACCORDION */}
        {/* <div className="AccordionBox" onClick={accordionClick}>
          <MenuAccordion />
        </div> */}
        {/* LIST MENU */}
        <div className="BoxListMenu">
          <p className="seoP5">Aditional Information</p>
          <nav>
            <ul onClick={HandleOpenCloseMenu}>
              <li>
                <Link href="/about-us">About us</Link>
              </li>
              <li>
                <Link href="/faq">FAQ</Link>
              </li>
              <li>
                <Link href="/affiliates">Affiliates</Link>
              </li>
              <li>
                <Link href="/responsible-gambling">Responsible Gambling</Link>
              </li>
              <li>
                <Link href="/policy">Privacy Policy</Link>
              </li>
              <li>
                <Link href="/terms">Terms and Conditions</Link>
              </li>
              {/* <li>
                <Link href="/blog">Blog</Link>
              </li> */}
            </ul>
          </nav>
        </div>
        {/* ACCEPT CRYPTO */}
        <div className="BoxAccCrypto">
          <p>Accepted Crypto Currencies</p>
          <div className="RoxCryptoBoxes">
            {/* SLIDER */}
            <Swiper
              modules={[Autoplay, Navigation]}
              spaceBetween={23}
              slidesPerView={4}
              pagination={{ clickable: true }}
              centeredSlides={false}
              autoplay={{
                delay: 1500,
                disableOnInteraction: false,
              }}
              navigation={false}
              loop={true}
            >
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_1"
                  alt="BITCOIN"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_2"
                  alt="Ethereum"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_3"
                  alt="Litecoin"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_4"
                  alt="Tether"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_5"
                  alt="BITCOIN"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_6"
                  alt="BINANCE"
                />
              </SwiperSlide>

              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_1"
                  alt="BITCOIN"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_2"
                  alt="Ethereum"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_3"
                  alt="Litecoin"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_4"
                  alt="Tether"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_5"
                  alt="BITCOIN"
                />
              </SwiperSlide>
              <SwiperSlide className="iconCryptoBox">
                <Image
                  width={50}
                  height={50}
                  src={CryptoIcons}
                  className="CryptoIcon CCI_6"
                  alt="BINANCE"
                />
              </SwiperSlide>
            </Swiper>
            {/* SLIDER */}
          </div>
          <p>And</p>
          <div id="DepMetods"></div>
          <p className="InfoCopy">
            ©<span>{new Date().getFullYear()}</span> Goat Spins CASINO ALL RIGHTS RESERVED
          </p>
        </div>
      </div>
      {/* CAP BACK MENU ON MOBILE */}
      <div id="BackCapMenu" onClick={HandleOpenCloseMenu}></div>
    </>
  );
};

export default MainMenu;
